import { Box, Text, Input, Flex } from "@chakra-ui/react";
import { useState } from "react";
import ModalLayout from "../Layout/ModalLayout";
import { toast } from "react-toastify";
import { adminUpdateLoanInfo } from "../../services/axios";

const UpdateLoanInfoModal = ({ loanRequest, isOpen, setIsOpen }) => {
  const [values, setValues] = useState({
    first_name: loanRequest.first_name || "",
    last_name: loanRequest.last_name || "",
    email: loanRequest.email || "",
    phone: loanRequest.phone || "",
    bvn: loanRequest.bvn || "",
    nin: loanRequest.nin || "",
    guarantor_name: loanRequest.guarantor_name || "",
    guarantor_email: loanRequest.guarantor_email || "",
    guarantor_phone: loanRequest.guarantor_phone || "",
  });

  const nextHandler = async () => {
    const res = await adminUpdateLoanInfo(values, loanRequest.request_id);
    if (res) {
      toast.success("Loan information updated successfully");
      setIsOpen(false);
      window.location.reload();
    }
  };

  return (
    <>
      <ModalLayout
        rejectHandler={() => nextHandler()}
        cancelBtnText="CANCEL"
        title="Edit Request Information"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        loading={false}
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={{ base: "4", md: "0" }}
          scrollPaddingX="4"
          marginTop="5"
        >
          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              First Name
            </Text>
            <Input
              value={values.first_name}
              className="form-input"
              onChange={(e) =>
                setValues({ ...values, first_name: e.target.value })
              }
            />
          </Box>
          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              Last Name
            </Text>
            <Input
              value={values.last_name}
              className="form-input"
              onChange={(e) =>
                setValues({ ...values, last_name: e.target.value })
              }
            />
          </Box>
        </Flex>

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={{ base: "4", md: "0" }}
          scrollPaddingX="4"
          marginY="5"
        >
          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              Email
            </Text>
            <Input
              value={values.email}
              className="form-input"
              onChange={(e) => setValues({ ...values, email: e.target.value })}
            />
          </Box>

          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              Phone Number
            </Text>
            <Input
              value={values.phone}
              className="form-input"
              onChange={(e) => setValues({ ...values, phone: e.target.value })}
            />
          </Box>
        </Flex>

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={{ base: "4", md: "0" }}
          scrollPaddingX="4"
          marginY="5"
        >
          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              BVN
            </Text>
            <Input
              type="number"
              value={values.bvn}
              className="form-input"
              onChange={(e) => setValues({ ...values, bvn: e.target.value })}
            />
          </Box>

          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              NIN
            </Text>
            <Input
              type="number"
              value={values.nin}
              className="form-input"
              onChange={(e) => setValues({ ...values, nin: e.target.value })}
            />
          </Box>
        </Flex>

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={{ base: "4", md: "0" }}
          scrollPaddingX="4"
          marginY="5"
        >
          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              Guarantor Name
            </Text>
            <Input
              type="text"
              value={values.guarantor_name}
              className="form-input"
              onChange={(e) =>
                setValues({ ...values, guarantor_name: e.target.value })
              }
            />
          </Box>

          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              Guarantor Phone Number
            </Text>
            <Input
              type="number"
              value={values.guarantor_phone}
              className="form-input"
              onChange={(e) =>
                setValues({ ...values, guarantor_phone: e.target.value })
              }
            />
          </Box>
        </Flex>

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={{ base: "4", md: "0" }}
          scrollPaddingX="4"
          marginY="5"
        >
          <Box flex={{ base: "1", md: "0 0 48%" }}>
            <Text color="#540A45" fontWeight="700" fontSize="14px">
              Guarantor Email
            </Text>
            <Input
              type="email"
              value={values.guarantor_email}
              className="form-input"
              onChange={(e) =>
                setValues({ ...values, guarantor_email: e.target.value })
              }
            />
          </Box>
        </Flex>
      </ModalLayout>
    </>
  );
};

export default UpdateLoanInfoModal;
